<template>
    <div>
        <template v-for="(observacion, i) in requerimiento.observaciones">
            <RequerimientoObservacion
                    :requerimiento="requerimiento"
                    :observacion="observacion"
                    :allowed="requerimiento.allowed"
                    :editable="true"
                    @updateObservacion="updateObservacion"
                    :key="i">
            </RequerimientoObservacion>
        </template>
        <div v-if="isAdminRole || isClubRole" class="observation-area">
            <div>Nuevo comentario:</div>
            <v-autocomplete v-if="isAdminRole" v-model="departamento" :items="departamentos" itemText="nombre" itemValue="id" label="Departamento"
                                :readonly="saving" :errorMessages="departamentoErrors" @input="$v.departamento.$touch()"
                                :loading="loadingDepartamentos"></v-autocomplete>
            <v-textarea v-model="observacionText" single-line outline></v-textarea>
        </div>
    </div>
</template>

<script>
import RequerimientoObservacion from './RequerimientoObservacion'

export default {
  components: {
    RequerimientoObservacion
  },
  props: {
    requerimiento: Object
  },

  data () {
    return {
      observacionText: '',
      editable: true,
      editing: false,
      editPath: 'observacion',
      loadingDepartamentos: false,
      departamentos: [],
      departamento: ''
    }
  },

  computed: {
    isAdminRole () {
      return this.requerimiento.allowed === 'admin'
    },
    isClubRole () {
      return this.requerimiento.allowed === 'user'
    }
  },

  methods: {
    isModified () {
      return this.observacionText !== ''
    },
    getObservacion () {
      return this.observacionText
    },
    cleanObservacion () {
      this.observacionText = ''
    },
    updateObservacion (observacionEdited) {
      let indexObservacion = this.requerimiento.observaciones.findIndex(observacion => observacion.pk === observacionEdited.pk)
      this.$set(this.requerimiento.observaciones, indexObservacion, observacionEdited)
    },
    fetchDepartamentos () {
      this.loadingDepartamentos = true
      this.axios
        .get('departamentos_by_usuario')
        .then(response => {
          this.departamentos = response.data
          this.loadingDepartamentos = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    getObservacionDepartamento () {
      return this.departamento
    },
    cleanDepartamento () {
      this.departamento = ''
    }
  },
  created () {
    this.fetchDepartamentos()
  }
}
</script>

<style scoped>
    .observation-area {
        background-color: #e9eaec;
        margin-top: 1em;
    }
</style>
